import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import VisibeenLogo from '../../assets/VisibeenLogo.png';

const Panel = styled(Box)(({ theme }) => ({
  width: '50%',
  minHeight: '100vh',
  padding: theme.spacing(5),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  overflow: 'hidden',
  backgroundColor: '#0B91D60F',
  [theme.breakpoints.down('md')]: {
    width: '100%',
    minHeight: 'auto',
    padding: theme.spacing(4, 3)
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(3, 2)
  }
}));

const LogoImage = styled('img')(({ theme }) => ({
  width: '119px',
  height: '40px',
  position: 'absolute',
  top: theme.spacing(5),
  left: theme.spacing(5),
  [theme.breakpoints.down('md')]: {
    top: theme.spacing(4),
    left: theme.spacing(3),
    width: '100px',
    height: '34px'
  },
  [theme.breakpoints.down('sm')]: {
    top: theme.spacing(3),
    left: theme.spacing(2),
    width: '90px',
    height: '30px'
  }
}));

const ContentContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  maxWidth: '450px',
  [theme.breakpoints.down('md')]: {
    maxWidth: '400px'
  },
  [theme.breakpoints.down('sm')]: {
    maxWidth: '100%'
  }
}));

const GifContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  minHeight: '300px',
  [theme.breakpoints.down('sm')]: {
    minHeight: '250px'
  }
}));

const GifImage = styled('img')(({ theme }) => ({
  width: '100%',
  height: 'auto',
  maxWidth: '350px',
  objectFit: 'contain',
  opacity: 0,
  transition: 'opacity 0.8s ease-in-out',
  position: 'absolute',
  '&.active': {
    opacity: 1
  },
  [theme.breakpoints.down('md')]: {
    maxWidth: '300px'
  },
  [theme.breakpoints.down('sm')]: {
    maxWidth: '250px'
  }
}));

const TitleText = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '32px',
  fontWeight: 600,
  color: '#333',
  marginTop: theme.spacing(4),
  textAlign: 'center',
  transition: 'opacity 0.8s ease-in-out',
  [theme.breakpoints.down('md')]: {
    fontSize: '28px'
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '24px'
  }
}));

const LeftPanel = () => {
  const [currentGifIndex, setCurrentGifIndex] = useState(0);

  const gifData = [
    { src: '/images/diagnose.gif', title: 'Diagnose' },
    { src: '/images/task.gif', title: 'Task' },
    { src: '/images/execution.gif', title: 'Execution' },
    { src: '/images/benchmarking.gif', title: 'Benchmarking' }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentGifIndex((prevIndex) => (prevIndex + 1) % gifData.length);
    }, 4000); // Change GIF every 4 seconds

    return () => clearInterval(interval);
  }, [gifData.length]);

  return (
    <Panel>
      <LogoImage src={VisibeenLogo} alt="Visibeen Logo" />
      <ContentContainer>
        <GifContainer>
          {gifData.map((gif, index) => (
            <GifImage
              key={gif.src}
              src={gif.src}
              alt={gif.title}
              className={index === currentGifIndex ? 'active' : ''}
            />
          ))}
        </GifContainer>
        <TitleText>{gifData[currentGifIndex].title}</TitleText>
      </ContentContainer>
    </Panel>
  );
};

export default LeftPanel;